import api from '@/apis/di/budgetItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Mục
export const useBudgetSubGroupItemComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetSubGroupItemComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [
      { Field: 'budget_item_type', Value: 1 },
      { Field: 'inactive', Value: false, Ors: ors },
    ];
    payload.filter = extendFilter(payload.filter, extend); // 1 Là tiểu nhóm
    payload.sort = 'budget_item_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const budgetSubGroupItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã nhóm',
        dataField: 'budget_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nhóm',
        dataField: 'budget_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_item_code',
    valueField: 'budget_item_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBudgetSubGroupItemComboboxLoadData,
    modelValueField: 'budget_sub_item_code',
  };

  // Sự kiện load combo trên grid
  return {
    budgetSubGroupItemComboConfig,
    onBudgetSubGroupItemComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
